export const NavbarLinks = [
    {title: "Home", path: '/'},
    {title: "Catalog", path: '/catalog'},
    {title: "About", path: '/about'},
    {title: "Contact Us", path: '/contact'}
]